/**
 * Created by Bimal James on 2014-10-08.
 */
define('all/player/uk-terms',['jquery', 'all/dialog', 'all/navigation', 'all/player/session', 'all/player/playerinfo', 'all/pretty-links','all/slidingContentWrapper'],
	function ($, dialog, navigation, session, playerinfo, prettyLinks, slidingContentWrapper) {
		'use strict';

		function loginFromAgreement(username, password, rememberme, termsagreed, captcha) {
			$.getJSON('/pp?flow=LoginJson', {
				PARAM_USER_NAME: username,
				PARAM_PASSWORD: password,
				PARAM_REMEMBER_ME: rememberme,
				PARAM_UK_TERMS_AGREED: termsagreed,
				PARAM_CAPTCHA_CODE: captcha,
				PARAM_TERM_CONDITION: "true"
			}, function (data) {
				if (data.RESULT === 'OK') {
					localStorage.setItem('isCustomer', 'true');
					dialog.closeAll();
					if (data.MAINTENANCE) {
						dialog.load('info', {
							title: data.HEADER_MAINTENANCE,
							heading: data.IN_HEADER,
							message: data.IN_MESSAGE
						});
					}
					$('#clock').data('offset', data.PARAM_TIME_ZONE);

					if (location.pathname === '' || location.pathname === '/' || location.hash.indexOf('login') > -1) {
						location.href = prettyLinks.getLink('MyPages', 'MyAccount');
					}
					var info = data.PARAM_PLAYER_INFO;
					if (typeof (info) !== 'undefined') {
						playerinfo.init(info);
						session.login();
					} else if(data.PARAM_MUST_CHANGE_PW) {
						//we dont pass player info to user if he/she needs to change pw, we have to handle this here as well
						slidingContentWrapper.showSlidingChangePassword();
					} else {
						console.error('login.doLogin', 'PARAM_PLAYER_INFO is undefined');
					}
				}

			});
		}

		window.ukterms = {
			loginFromAgreement: loginFromAgreement
		};

		return window.ukterms;
	});

